import { Font, StyleSheet } from "@react-pdf/renderer";

Font.register({
  family: "Helvetica",
  fonts: [
    { src: "Helvetica" }, // regular
    { src: "Helvetica-Bold", fontWeight: "bold" }, // bold
  ],
});

const PRIMARY_BLUE = "#0057B7";
const YELLOW = "#FFEB3B";

const styles = StyleSheet.create({
  // Page container

  page: {
    padding: 20,
    paddingBottom: 110,
    fontSize: 12,
    fontFamily: "Helvetica",
    color: "#333",
    position: "relative",
  },
  mainContent: {
    flex: 1,
  },
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    width: "100%",
  },

  companyAndQuoteRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
  },

  leftBlock: {
    flexDirection: "column",
    alignItems: "flex-start",
    flex: 1,
  },
  logo: {
    width: 160,
    height: 40,
    marginTop: 10,
    marginRight: 10,
    marginBottom: 20,
    objectFit: "cover",
  },
  companyBlock: {
    flexDirection: "column",
    justifyContent: "center",
  },
  companyName: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    textTransform: "uppercase",
  },
  companyAddress: {
    fontSize: 12,
    lineHeight: 1.2,
    marginTop: 2,
  },
  gstInfo: {
    fontSize: 12,
    marginTop: 2,
  },

  quotationBox: {
    backgroundColor: "#FFEB3B",
    paddingVertical: 10,
    paddingHorizontal: 40,
    borderRadius: 4,
    justifyContent: "center",
    alignItems: "flex-end",
    height: 100,
    alignSelf: "flex-start",
    marginTop: -20,
  },
  quotationText: {
    fontSize: 32,
    fontFamily: "Helvetica-Bold",
    textTransform: "uppercase",
    textAlign: "right",
  },

  invoiceTitleContainer: {
    backgroundColor: "#FFEB3B",
    paddingVertical: 8,
    paddingHorizontal: 20,
    justifyContent: "center",
    alignItems: "flex-end",

    alignSelf: "flex-start",
  },
  invoiceTitle: {
    fontSize: 32,
    fontFamily: "Helvetica-Bold",
    textTransform: "uppercase",
    color: "#000",
  },

  sectionTitle: {
    fontSize: 16,
    textTransform: "uppercase",
    fontFamily: "Helvetica-Bold",
    marginTop: 6,
    marginBottom: 4,
  },
  infoRow: {
    flexDirection: "row",
    marginBottom: 4,
    alignItems: "flex-start",
  },
  infoLabel: {
    width: 70,
    fontSize: 12,
    textAlign: "left",
  },
  smallInfo: {
    width: 90,
    fontSize: 12,
    textAlign: "left",
  },

  infoValue: {
    flex: 1,
    fontSize: 12,
    paddingLeft: 0,
  },

  clientInfo: {
    marginBottom: 10,
    flex: 1,
  },
  clientInfoItem: {
    fontSize: 12,
    marginBottom: 4,
  },

  clientInfoHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: 4,
    marginBottom: 4,
    gap: 40,
  },

  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginBottom: 8,
  },

  singleLineHeader: {
    lineHeight: 0.8,
    paddingTop: 9,
    justifyContent: "center",
    alignItems: "center",
  },
  tableRow: {
    flexDirection: "row",
    alignItems: "stretch",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  tableHeader: {
    backgroundColor: PRIMARY_BLUE,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  tableHeaderText: {
    color: "#fff",
    fontSize: 8,
    fontWeight: "bold",
    textAlign: "center",
    padding: 4,
    lineHeight: 1.2,
    borderRightWidth: 1,
    borderRightColor: "#000",
    height: "100%",
    display: "flex",
    justifyContent: "center",
  },

  tableCell: {
    fontSize: 10,
    padding: 4,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#000",
    height: "100%",
    display: "flex",
    justifyContent: "center",
  },
  tableCellDesc: {
    fontSize: 10,
    padding: 4,
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#000",
    height: "100%",
    display: "flex",
    justifyContent: "center",
  },

  slNoCell: {
    flex: 0.5,
    textAlign: "center",
  },
  descriptionCell: {
    flex: 2,
    textAlign: "center",
  },
  hsnCell: {
    flex: 1,
    textAlign: "center",
  },
  qtyCell: {
    flex: 1,
    textAlign: "center",
  },
  rateCell: {
    flex: 1,
    textAlign: "center",
  },
  totalCell: {
    flex: 1,
    textAlign: "center",
    borderRightWidth: 0,
  },

  totals: {
    marginTop: 10,
    marginBottom: 10,
    width: "30%",
    alignSelf: "flex-end",
    paddingRight: 20,
  },
  totalRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
  },
  totalLabel: {
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
  },
  totalValue: {
    fontSize: 12,
    textAlign: "right",
  },

  terms: {
    marginTop: 12,
    paddingBottom: 10,
    lineHeight: 0.8,
  },
  termsTitle: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    marginBottom: 10,
  },
  bankTitle: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    marginBottom: 4,
  },
  termsItem: {
    fontSize: 12,
    marginBottom: 2,
  },

  footerContainer: {
    position: "absolute",
    bottom: 45,
    left: 0,
    right: 0,
  },
  footer: {
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: PRIMARY_BLUE,
    padding: 10,
    marginLeft: 20,
    marginRight: 10,
  },
  subFooter: {
    padding: 10,
    justifyContent: "center",
  },
  jurisdictionText: {
    textAlign: "center",
    fontSize: 10,
  },
  footerText: {
    fontSize: 12,
    color: "#fff",
  },

  bankDetailsTable: {
    padding: 8,
  },
  bankRow: {
    flexDirection: "row",
    marginBottom: 4,
  },
  bankLabel: {
    width: 100,
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  bankValue: {
    flex: 1,
    fontSize: 12,
    fontFamily: "Helvetica",
    fontWeight: "bold",
  },

  textSmallest: {
    fontSize: 8,
    textAlign: "left",
    marginBottom: 2,
  },

  metaContainer: {
    flexDirection: "column",
    width: "40%",
    marginLeft: 20,
  },
  createdInfo: {
    fontSize: 8,
    marginTop: 2,
    color: "#555",
    textAlign: "right",
  },

  logoContainer: {
    width: 100,
    height: 100,
    marginRight: 10,
  },

  companyInfo: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 10,
  },
  addressRow: {
    flexDirection: "row",
    marginBottom: 4,
  },
  addressLabel: {
    width: 70,
    textAlign: "left",
  },
  addressValue: {
    flex: 1,
    paddingLeft: 5,
  },
  piInfoContainer: {
    marginTop: 10,
  },
  piInfoRow: {
    flexDirection: "row",
    marginBottom: 4,
  },
  addressContainer: {
    width: "48%",
    marginBottom: 10,
  },
  label: {
    width: 70,
    fontWeight: "bold",
  },
  value: {
    flex: 1,
  },
  dateBox: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
    borderRadius: 4,
    textAlign: "center",
  },
  billTable: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
  },
  billTable2: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
    padding: 5,
  },
  billHeader: {
    backgroundColor: "#f0f0f0",
    fontWeight: "bold",
    flexDirection: "row",
  },
  billCell: {
    padding: 5,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    textAlign: "center",
  },

  perCell: { flex: 0.5 },
  amountCell: { flex: 1 },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
  },
  text: {
    fontSize: 10,
    marginBottom: 3,
  },

  billingInfo: {
    fontSize: 10,
    marginBottom: 3,
  },
  billingTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
  },

  piDate: {
    fontSize: 10,
    marginTop: 4,
  },
  boldText: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
  },
  totalSection: {
    marginTop: 10,
    textAlign: "right",
  },
  textContainer: {
    textAlign: "right",
  },
  overallTotalContainer: {
    marginTop: 10,
    borderTopWidth: 2,
    borderTopColor: "#000",
  },
  overallTotalText: {
    fontSize: 14,
    fontWeight: "bold",
  },
});

export default styles;
